import { render, staticRenderFns } from "./AmountInput.vue?vue&type=template&id=052c0462&scoped=true&"
import script from "./AmountInput.vue?vue&type=script&lang=ts&"
export * from "./AmountInput.vue?vue&type=script&lang=ts&"
import style0 from "./AmountInput.vue?vue&type=style&index=0&id=052c0462&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052c0462",
  null
  
)

export default component.exports